
  // Auto rotate tabs --- selector: autorotate
  var tabChange = function(){
    var tabs = $('.nav-tabs.autorotate > a');
    var active = tabs.filter('.active');
    var next = active.next().length ? active.next() : tabs.filter(':first-child');
    //Bootsrap tab show method
    active.removeClass('active');
    next.tab('show');
  }
  
  var tabCycle = setInterval(tabChange, 5000);

  // Tab click event handler
  $(function(){
      // Pause on mouseenter and resume on mouseleave
      $('.container--nav-tabs-autorotate')
      .on('mouseenter', function(e) {
        e.preventDefault();
        clearInterval(tabCycle);
      })
      .on('mouseleave', function() {
        tabCycle = setInterval(tabChange, 5000);
      });

      // Stop on click
      $('.nav-tabs a').on('click', function(e) {
          e.preventDefault();
          var tabs = $('.nav-tabs.autorotate > a');

          // Removed other active tab
          var active = tabs.filter('.active');
          active.removeClass('active');

          clearInterval(tabCycle);

          $(this).tab('show') // Show clicked one
          // Start the cycle again in a predefined amount of time
          // setTimeout(function(){
          //     tabCycle = setInterval(tabChange, 5000)
          // }, 5000);
      });
  });


// WEBPACK FOOTER //
// ./scripts/routes/autoRotateTabs.js